<template>
  <div class="checkout-payment-display">
    <p class="header">
      {{ $t('cart.paymentCount') }} {{ index }}
    </p>
    <p class="amount">
      {{ formattedAmount }} {{ $t('dueDate', {date: formattedDate}) }}
    </p>
  </div>
</template>

<script>
/* global locale */
import CurrencyApi from '../../../default/currency_convert/currency-api'

export default {

  props: ['currency', 'index', 'term'],
  computed: {
    dueDate() {
      if (this.term.due_date == undefined) {
        return new Date()
      } else {
        return new Date(this.term.due_date)
      }
    },

    formattedAmount() {
      return CurrencyApi.formatAmount(this.term.amount / 100.0, this.currency)
    },

    formattedDate() {
      if (this.dueDate <= new Date()) {
        return this.$t('today')
      } else {
        return this.dueDate.toLocaleString(locale, {
          month: 'long',
          day: 'numeric',
          year: 'numeric'
        })
      }
    },
  },
}
</script>
